"use strict";
var react_redux_1 = require('react-redux');
var ComponentBuilder = (function () {
    function ComponentBuilder(stateToProps, actionCreators) {
        this.stateToProps = stateToProps;
        this.actionCreators = actionCreators;
    }
    ComponentBuilder.prototype.withExternalProps = function () {
        return this;
    };
    Object.defineProperty(ComponentBuilder.prototype, "allProps", {
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    ComponentBuilder.prototype.connect = function (componentClass) {
        return react_redux_1.connect(this.stateToProps, this.actionCreators)(componentClass);
    };
    return ComponentBuilder;
}());
exports.ComponentBuilder = ComponentBuilder;
function provide(stateToProps, actionCreators) {
    return new ComponentBuilder(stateToProps, actionCreators);
}
exports.provide = provide;
